<template>
  <div
    id="teams"
    class="mainCard"
  >
    <!--<div class="filter">
      <el-input
        v-model="filterText"
        class="filterText"
        placeholder="Search"
        @change="loadUsers('change')"
      >
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="loadUsers"
        />
      </el-input>
    </div>-->

    <el-table
      v-loading="loading"
      :data="teams"
      style="width: 100%;"
      class="teamsList clear-table"
      :empty-text="$t('oa.team.noData')"
      @row-click="goToDetail"
    >
      <el-table-column
        prop="name"
        :label="$t('common.team')"
      />
      <el-table-column
        :label="$t('aside.leaders')"
        align="left"
      >
        <template slot-scope="scope">
          {{ (scope.row.invited_leader_ct || 0) + (scope.row.member_count || 0) }}
        </template>
      </el-table-column>

      <el-table-column
        width="80"
      >
        <template slot-scope="scope">
          <el-button
            class="teamDeleteBtn"
            icon="el-icon-delete"
            circle
            :disabled="processDelete"
            @click.stop="confirmDelete(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>

    <div
      class="addTeamButton"
      @click="createTeam = true"
    >
      + {{ $t('oa.team.addNewTeam') }}
    </div>

    <el-pagination
      layout="prev, pager, next"
      :total="count"
      :current-page.sync="currentPage"
      @current-change="getTeams"
    />

    <CreateTeam
      :show.sync="createTeam"
      @newTeam="getTeams"
    />
  </div>
</template>

<script>
import api from '@/api';
import CreateTeam from './CreateTeam.vue';

export default {
  components: {
    CreateTeam,
  },

  data() {
    return {
      teams: [],
      createTeam: false,
      currentPage: 1,
      count: 0,
      loading: false,
      processDelete: false,
    };
  },

  created() {
    this.getTeams();
  },

  methods: {
    async getTeams() {
      try {
        this.loading = true;
        const response = await api.getTeams();
        this.teams = response.data.results;
        this.count = response.data.count;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    goToDetail(row) {
      this.$router.push({ name: 'teamDetail', params: { id: row.uuid } }).catch((err) => {});
    },

    async confirmDelete(data) {
      if (data.member_count === 0) {
        this.$alert(this.$t('oa.team.confirmDeleteTeam'), '', {
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('common.delete'),
          cancelButtonText: this.$t('common.goBack'),
        }).then(() => {
          this.deleteTeam(data);
        }).catch(() => {});
      } else {
        this.$message.error(this.$t('oa.team.errorDeleteTeam'));
      }
    },

    async deleteTeam(data) {
      try {
        this.processDelete = true;
        await api.deleteTeam(data.uuid);
        this.$message.success(this.$t('oa.team.teamDeleted'));
        this.getTeams();
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.processDelete = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  #teams {
    .addTeamButton {
      background-color: transparent;
      border: 1px dashed var(--themeFontColor);
      color: var(--themeFontColor);
      cursor: pointer;
      margin-top: 15px;
      height: 68px;
      line-height: 68px;
      border-radius: 10px;
      text-align: center;

      &:hover {
        background-color: rgba(255, 255, 255, 0.3);
      }
    }

    .teamDeleteBtn {
      background: transparent;
      border-width: 0;
      color: var(--themeFontColor);

      &:hover { background: rgba(255, 255, 255, 0.2); }
      &:active { background: rgba(255, 255, 255, 0.5); }
    }
  }
</style>

<style lang="scss">
  #teams {
    .teamsList {
      tr {
        & > th:first-child,
        & > td:first-child {
          .cell {
            padding-left: 15px;
          }
        }
      }

      tbody tr {
        cursor: pointer;
      }

      .el-table__header {
        tr {
          th:first-child {
            padding-left: 15px;
          }
        }
      }

      .el-table__row {
        td:first-child {
          padding-left: 15px;
        }
      }
    }
  }
</style>
